/**
 * *Saving to* — the chips that say where something made at a stop is going
 * (Boards 14 C, 15 A, 15 B): a job wears the stack, a place the pin, a
 * person the head, each a 22 px chip on `surface-alt` (the boards' 20 and their border).
 */
import type { RecordRef } from '@rowted/shared'
import { cn } from '../../lib/cn.js'
import { Glyph, type GlyphName } from '../glyphs.js'

export interface SaveChip extends RecordRef {
  label: string
}

const GLYPH: Partial<Record<RecordRef['type'], GlyphName>> = {
  job: 'layers',
  property: 'pin',
  contact: 'user',
}

export function SavingTo({
  word = 'Saving to', chips, onAdd, className, large = false,
}: {
  /** *Saving to* on the scope screens, *Saves to* in the call log. */
  word?: string
  /** The call log's 13 px words (Board 14 C) rather than the scope screens' 12.5. */
  large?: boolean
  chips: SaveChip[]
  /** Opened from New with nothing behind it: a way to say where (§9.2). */
  onAdd?: () => void
  className?: string
}) {
  return (
    <div className={cn('flex flex-wrap items-center gap-2 text-text-muted', large ? 'text-[13px]' : 'text-[12.5px]', className)}>
      {word}
      {chips.map((chip) => (
        <span key={`${chip.type}:${chip.id}`}
          className={cn('inline-flex h-[22px] items-center gap-1 whitespace-nowrap rounded-md border border-line-faint',
            'bg-surface-alt px-[7px] text-[11px] font-semibold text-text-body')}>
          <span className="inline-flex text-text-muted"><Glyph name={GLYPH[chip.type] ?? 'file'} size={11} /></span>
          {chip.label}
        </span>
      ))}
      {onAdd && (
        <button type="button" onClick={onAdd}
          className={cn('inline-flex h-[22px] items-center gap-1 whitespace-nowrap rounded-md border border-dashed',
            'border-accent-line px-[7px] text-[11px] font-semibold text-accent')}>
          <Glyph name="plus" size={11} />Attach
        </button>
      )}
    </div>
  )
}
